import { MINUS, NBSP, PLUS } from './consts';

function getSymbolData({ currencyCode, locale }: { currencyCode: string; locale?: string }) {
  try {
    const testValueWithSymbol = (0).toLocaleString(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      currency: currencyCode,
      style: 'currency'
    });

    const isSymbolBefore = /^.+0$/.test(testValueWithSymbol);

    const symbol = isSymbolBefore
      ? testValueWithSymbol.substring(0, testValueWithSymbol.length - 1)
      : testValueWithSymbol.substring(1);

    const position = isSymbolBefore ? 'before' : 'after';

    return { symbol, position };
  } catch (e) {
    // error means that here is no symbol for this code
    return {
      symbol: `${NBSP}${currencyCode}`,
      position: 'after'
    };
  }
}

interface InsertCurrencyProps {
  locale?: string;
  formattedValue: string;
  currencyCode: string;
}

export function insertCurrency({ locale, formattedValue, currencyCode }: InsertCurrencyProps) {
  const { symbol, position } = getSymbolData({ locale, currencyCode });

  if (position === 'before') {
    if (formattedValue.startsWith(MINUS)) {
      return `${MINUS}${symbol}${formattedValue.substring(1)}`;
    }

    if (formattedValue.startsWith(PLUS)) {
      return `${PLUS}${symbol}${formattedValue.substring(1)}`;
    }

    return `${symbol}${formattedValue}`;
  }

  return `${formattedValue}${symbol}`;
}
